<h1>{{ i18n.langString("cookie_consent") }}</h1>
<br />
@for (key of contentParagraphKeys; track key) {
  @if (key === "cookie_consent_subtitle") {
    <p class="body-bold">{{ i18n.langString(key) }}</p>
  } @else {
    <p class="cookie-consent-content">
      {{ i18n.langString(key) }}
    </p>
  }
  @if (key !== "cookie_consent_sixth_paragraph") {
    <br />
  }
  @if (
    key === "cookie_consent_second_paragraph" ||
    key === "cookie_consent_fourth_paragraph" ||
    key === "cookie_consent_sixth_paragraph"
  ) {
    <br />
  }
}
<app-nav-button
  [darksecondary]="true"
  svgIcon="icons:arrow-left"
  (clickEvent)="gotoLogin()"
>
  {{ i18n.langString("back") }}
</app-nav-button>
